/**
 * toDiveideDatePicker
 * ラジオボタンのチェックを監視し、カレンダーマスターの日付選択フォームを出し分ける
 */
$('.js-radio[name="specified-delivery"]').on('change', function() {
  var type = $(this).val();
  if (type == 'earliest') {
    $('.js-datePicker').hide();
    $('input[name="year"]').val('').css('width', '28px');
    $('input[name="month"]').val('').css('width', '14px');
    $('input[name="day"]').val('').css('width', '14px');
  } else if (type == 'specify') {
    $('.js-datePicker').show();
  }

});